// src/PricingModal.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PricingSection.css';

const PricingModal = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const plans = [
    {
      name: "Basic",
      price: "£49 / month per branch",
      yearly: "(£490 when billed annually)",
      description: "",
      idealFor: "Internal use only: Ideal for valuations, buyer conversations, and internal research.",
      features: [
        "Unlimited searches",
        "Overall Amenity Score",
        "Top 3 amenity categories",
        "Full breakdown of amenities",
        "AI street and area insights",
        "Compare streets and areas",
        "Unlimited users per branch"
      ],
    //   cta: "Start Free Trial",
      popular: false
    },
    // {
    //   name: "Pro",
    //   price: "£79 per month",
    //   // yearly: "or £15k yearly",
    //   description: "",
    //   idealFor: "Perfect for individual agents and small teams",
    //   features: [
    //     "internal use",
    //     "unlimited usage on listings"
    //     // "20 area searches per month",
    //     // "API access",
    //     // "Email support",
    //   ],
    // //   cta: "Start Free Trial",
    //   popular: false
    // },
    {
      name: "Pro",
      price: "£79 / month per branch",
      yearly: "(£790 when billed annually)",
      description: "",
      idealFor: "Internal + external use. Ideal for agencies wanting a marketing and valuation differentiator. Everything in Basic + the use of amenity scores externally in listings and brochures.",
      features: [
         "Unlimited searches",
        "Overall Amenity Score",
        "Top 3 amenity categories",
        "Full breakdown of amenities",
        "AI street and area insights",
        "Compare streets and areas",
        "Unlimited users per branch",
        "Embed scores on website listings via API",
        "Include in listing brochures and marketing material"
        // "50 area searches per month",
        // "API access",
        // "Bulk export tools"
      ],
    //   cta: "Start Free Trial",
      popular: true
    },
    // {
    //   name: "Enterprise",
    //   price: "£1,500 per month per branch",
    //   yearly: "or £15k yearly per branch",
    //   description: "",
    //   idealFor: "For large agencies and property portals",
    //   features: [
    //     "Unlimited searches",
    //     "Custom integrations",
    //     "Account manager"
    //     ],
    // //   cta: "Contact Sales",
    //   popular: false
    // }
  ];

  return (
    <section className="pricing-section">
      <div className="pricing-container">
        <div className="pricing-intro">
          <h2>Simple, Transparent Pricing</h2>
          <p>Choose the plan that fits your business</p>
          <button 
            className="view-pricing-button"
            onClick={() => setShowModal(true)}
          >
            View Pricing Plans
          </button>
        </div>
      </div>

      {showModal && (
        <div className="pricing-modal">
          <div className="modal-overlay" onClick={() => setShowModal(false)}></div>
          
          <div className="modal-content">
            <div className="modal-header">
              <h2>Our Pricing Plans</h2>
              {/* <p>Select the perfect plan for your business needs</p> */}
              <button 
                className="close-button"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
            </div>
            
            <div className="pricing-grid">
              {plans.map((plan, index) => (
                <div 
                  key={index} 
                  className={`pricing-card ${plan.popular ? 'popular' : ''}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => { setShowModal(false); navigate('/signup'); }}
                  onKeyPress={(e) => { if (e.key === 'Enter') { setShowModal(false); navigate('/signup'); } }}
                >
                  {plan.popular && <div className="popular-badge">Most Popular</div>}
                  <h3>{plan.name}</h3>
                  <div className="price">
                    <div>{plan.price}</div>
                    {plan.yearly && <div className="yearly">{plan.yearly}</div>}
                  </div>
                  <p className="ideal-for">{plan.idealFor}</p>
                  <ul className="features">
                    {plan.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                  {/* <button className="cta-button">{plan.cta}</button> */}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PricingModal;